module.exports = __webpack_public_path__ + "img/1.2a5ac817.png";